import { useState } from "react";
import styles from "./LongitudinalBar.module.css";

function LongitudinalBar({ input, onChange }) {
  const [barCount, setBarCount] = useState("");
  const [barDiameter, setBarDiameter] = useState(6.3);
  const [steelArea, setSteelArea] = useState(0);

  function getAs(count, diameter) {
    const as = count * ((Math.PI * (diameter / 10) ** 2) / 4);
    setSteelArea(as);
    if (onChange) onChange(input, as);
  }

  return (
    <form className={styles.component}>
      <input
        className={styles.componentInput}
        onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key) || barCount.length >= 2) {
            event.preventDefault();
          }
        }}
        onChange={(ev) => {
          setBarCount(ev.target.value);
          getAs(ev.target.value, barDiameter);
        }}
        value={barCount}
      ></input>
      <label className={styles.componentText}>Ø</label>
      <select
        className={styles.componentElements}
        onChange={(ev) => {
          setBarDiameter(ev.target.value);
          getAs(barCount, ev.target.value);
        }}
        value={barDiameter}
      >
        {[6.3, 8, 10, 12.5, 16, 20, 25, 32].map((element, i) => (
          <option key={i} value={element}>
            {element}
          </option>
        ))}
      </select>
      <label className={styles.componentText}>
        {"(" + "As,adot" + "=" + steelArea.toFixed(2) + " cm²" + ")"}
      </label>
    </form>
  );
}

export default LongitudinalBar;
